import React from 'react'
import '../Styles/HomeDemo.css'
import { Link } from 'react-router-dom'

const HomeDemo = ({image,title,content,btntext}) => {
  return (
    <div className='demo-card'>
    <div className='card-top'>
        <img src={image} className='card-top-img'/>
    </div>
    <div className='card-bottom'>
            <div className='card-bottom-title'>{title}</div>
            <p className='card-bottom-content'>{content}</p>
            <Link to='/Contact' className='link'>
            <button className='card-bottom-btn'>{btntext}</button>
            </Link>
    </div>
    </div>
  )
}

export default HomeDemo